import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import DraggableComponent from '../../../Components/DraggableComponent'
import { useFormik } from 'formik';
import Select, { components } from 'react-select';
import { CommonUtil } from '../../../utils/CommonUtil';
import { NetworkManager } from '../../../Components/NetworkManager';
import $ from 'jquery'
import * as Yup from "yup";
import ToastManager from '../../../Components/ToastManager';
import DescriptionPicture from './DescriptionPicture';
import ProcessTypeSpecific from './ProcessTypeSpecific';
import PDFTemplateConfig from './PDFTemplateConfig';
import InputField from '../../../Components/InputField';
import ReactSelectField from '../../../Components/ReactSelectField';
import SelectField from '../../../Components/SelectField';

const ModalTaskList = ({open, close, data, modalType, isEdit }:any) => {
  const sassOrgId = CommonUtil.getSaasOrgId();
  const [submitType, setSubmitType] = useState<"add" | "save" | "cancel">("add");
  const [processes, setProcesses] = useState<any>({});
  const [processTypeData, setProcessTypeData] = useState<any>({});
  const [processById, setProcessById] = useState<any>({});
  const [pictureDescription, setPictureDescription] = useState<any>({});
  const [pdfTemplateConfig, setPdfTemplateConfig] = useState<any>({});
  const [subtaskName, setSubtaskName] = useState<any>("");
  const [subtaskDes, setSubtaskDes] = useState<any>("");

  useEffect(() => {
    getAllProcesses();
  }, []);

  useEffect(() => {
    if(modalType === "equipment"){
    getProcessById(data?.id);
    }else if(modalType === "task"){
      getProcessById(data?.processId);
    }
  }, [modalType]);

  useEffect(() => {
    if (isEdit !== "equipment" && data) {
      taskFormik.setValues({
        processType: data?.processType || "",
        taskView: data?.taskView || "",
        taskName: data?.taskName || "",
        taskDescription: data?.taskDescription || "",
      });
    if(isEdit === "subtask" && modalType === "subtask"){
      setSubtaskName(data?.name || "");
      setSubtaskDes(data?.description || "");
    }
    }
  }, [isEdit, data]);


  const onLoginError = (err: any) => {
    console.log(err);
  };

  const getAllProcesses = () => {
    const orgUrl = `api/v2/config/processes/?orgId=${sassOrgId}`;
    NetworkManager.sendJsonRequest( orgUrl, "", "", "GET", true, onGetAllProcesses, onLoginError );
  };
    
  const onGetAllProcesses = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && restData.length > 0) {
        const updatedData = restData.map((process: any) => ({
          ...process,
          equipmentTypes: process.equipmentTypes.map((item: any) => {
            const key = Object.keys(item)[0];
            return { label: key, value: item[key] };
          }),
        }));
        setProcesses(updatedData[0]);
      } else {
        setProcesses({});
      }
    }
  };

  const getProcessById = (id:any) => {
    const orgUrl = `api/v2/config/processes/${id}/?orgId=${sassOrgId}`;
    NetworkManager.sendJsonRequest( orgUrl, "", "", "GET", true, onGetProcessById, onLoginError );
  }
  const onGetProcessById = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData) {
        const updatedData = {
          ...restData,
          equipmentTypes: restData.equipmentTypes.map((item: any) => {
            const key = Object.keys(item)[0];
            return { label: key, value: item[key] };
          }),
          processTypes: restData.processTypes.map((item: any) => ({
            label: item,
            value: item,
          })),
        };
        setProcessById(updatedData);
      } else {
        setProcessById({});
      }
    }
  };

  useEffect(() => {
    if (
      modalType === "equipment" &&
      open &&
      Array.isArray(processById.equipmentTypes) &&
      processById.equipmentTypes.length > 0 &&
      processById.equipmentTypes[0].value === 0
    ) {
      equipFormik.setFieldValue("equipmentType", processById.equipmentTypes);
    }
  }, [modalType, open, processById.equipmentTypes]);
  

  const getProcessTypeData = (item:any) => {
    setProcessTypeData(item);
  }

  const getPictureDescription = (item: any) => {
    if(item){
      setPictureDescription(item);
    }
  };

  const getPdfTemplateConfig = (item: any) => {
    if(item){
      setPdfTemplateConfig(item);
    }
  };

  const handleProcessChange = (e: any) => {
    taskFormik.handleChange(e);
    taskFormik.setFieldValue("taskView", "");
  }

  const equipValidation = Yup.object().shape({
    equipmentType: Yup.array()
      .min(1, 'At least one equipment type is required')
      .required('Equipment Type is required'),
  });
    
  const taskValidation = Yup.object().shape({
    processType: Yup.string()
      .required('Process Type is required'),
    taskView: Yup.string()
      .required('Task List View is required'),
    taskName: Yup.string()
      .trim()
      .min(3, 'Task Name must be at least 3 characters')
      .max(256, 'Task Name cannot exceed 100 characters')
      .required('Task Name is required'),
    // taskDescription: Yup.string()
    //   .trim()
    //   .min(10, 'Task Description must be at least 10 characters')
    //   .max(500, 'Task Description cannot exceed 500 characters')
    //   .required('Task Description is required'),
  });

  const taskFormik = useFormik({
    initialValues: {
    processType: "",
    taskView: "",
    taskName: "",
    taskDescription: "",
    },
    validationSchema: taskValidation,
    onSubmit: (values, { resetForm }) => {
        onSubmitForm(values);
        if (submitType === "save") {
          if(subtaskName === "" && modalType !== "subtask"){
          close("save");
          }
        }else if(submitType === "add" && modalType === "subtask"){
          taskFormik.setFieldValue("taskName", values?.taskName);
          taskFormik.setFieldValue("taskView", values?.taskView);
          setSubtaskName("");
          setSubtaskDes("");
        }else {
          resetForm();
        }
    },
  });

  const onSubmitForm = (values: any) => {
    
    if(modalType === "subtask"){
      if(subtaskName === "" && submitType === "save"){
        ToastManager.showToast("Subtask Name is Mandatory", "Error");
        return;
      }
      const subTaskPayload = {
        subTaskName: subtaskName,
        subTaskDescription: subtaskDes,
        taskId:  data?.taskId,
        subTasksId: data?.subTaskId,
        saasOrgId: sassOrgId
      }
      console.log(subTaskPayload, "payload");
      const url = isEdit === "subtask" ? `api/v2/config/subtasks/${data?.subTaskId}/?orgId=${sassOrgId}` : `api/v2/config/subtasks/?orgId=${sassOrgId}`;
      NetworkManager.sendJsonRequest(url, subTaskPayload, "", `${isEdit === "subtask" ? "PUT" : "POST"}`, true, onSubmitTask, onLoginError);
    }else{
      const getAttributeCount = (name: string) => {
        if(processTypeData?.attributeCounts){
             const attr = processTypeData.attributeCounts.find((a: any) => a.attributeName === name);
             return attr ? attr.count : 0;
        }
        return 0;
      };

      const payload = {
        ...values,
        tyreDetails: {
          tyreBrands: processTypeData?.enableTyreBrands ? processTypeData.selectedTyreBrands?.map((item: any) => 
            {return { brandName: item.label, brandId: item.value }}) : [],
          tyreSize: processTypeData?.enableTyreSizes ? processTypeData.selectedTyreSizes?.map((item: any) => 
            {return { sizeName: item.label, sizeId: item.value }}) : [],
          tyredepth: processTypeData?.enableTyreDepth ? processTypeData.selectedTyreDepth?.map((item: any) => 
            {return { depthName: item.label, depthId: item.value }}) : [],
          tyreCondition: processTypeData?.enableTyreCondition ? processTypeData?.tyreCondition?.map((item: any) => item.value) : [],
          tyreStatus: processTypeData?.selectTyreStatus ? processTypeData?.tyreStatus?.map((item: any) => item.value) : [],
          requiredTyreFields: processTypeData?.requiredTyreFields,
        },
        lightTypes: processTypeData?.lightTypes?.map((item: any) => item.value) || [],
        multiStatus: processTypeData?.multiStatus?.map((item: any) => item.value) || [],
        isStatusConfirmation: processTypeData?.isStatusConfirmation,
        repeatForAllTires: processTypeData?.repeatForAllTires,
        enableLightTypeCount: processTypeData?.enableLightTypeCount,
        enableLightType: processTypeData?.enableLightType,
        temperatureValue: processTypeData?.temperatureValue,
        hoursValue: processTypeData?.hoursValue,
        presetValue: processTypeData?.presetValue,
        reflectorRequired: processTypeData?.reflectorRequired,
        reflectorStatus: processTypeData?.reflectorStatus ? processTypeData?.reflectorStatus?.map((item: any) => item.value) : [],
        reflectorCountRequired: processTypeData?.reflectorCountRequired,
        assistedPictureRequired: pictureDescription?.assistedPictureRequired || false,
        assistedPicturePath: pictureDescription?.imageFiles?.path || null,
        assistedPictureName: pictureDescription?.imageFiles?.name || null,
        isTaskDescriptionMarked: pictureDescription?.isTaskDescriptionMarked || false,
        descriptionMarkedValue: pictureDescription?.isTaskDescriptionMarked ? pictureDescription?.descriptionMarkedValue?.map((type: any) => type.value) : null,
        isTaskPictureMarked: pictureDescription?.isTaskPictureMarked || false,
        pictureMarkedValue: pictureDescription?.isTaskPictureMarked ? pictureDescription?.pictureMarkedValue?.map((type: any) => type.value) : null,
        isDescriptionMandatory: pictureDescription?.isDescriptionMandatory || false,
        isMultiPicture: pictureDescription?.isMultiPicture || false,
        isPictureMandatory: pictureDescription?.isPictureMandatory || false,
        pdfImageAssignment: pdfTemplateConfig?.pdfImageAssignment || "",
        pdfImageAssignmentStatus: pdfTemplateConfig?.pdfImageAssignmentStatus || "",
        processId: processById.processId,
        assetTypeId: processById.assetTypeId,
        equipmentTypeGroupId: data?.equipmentTypeGroupId,
        taskId: data?.taskId,
        orgId: sassOrgId,
        sequenceId: data?.children?.length+1,
        attributeCounts: processTypeData?.attributeCounts || [],
        ...(values.processType === "Tire and Brakes" && {
            tireThreadDepth: getAttributeCount("Tread Depth"),
            brakes: getAttributeCount("Brake %")
        })
      }
      console.log(payload, "payload");
      const url = isEdit === "task" ? `api/v2/config/tasks/${data?.taskId}/?orgId=${sassOrgId}` : `api/v2/config/tasks/?orgId=${sassOrgId}`;
      NetworkManager.sendJsonRequest(url, payload, "", `${isEdit === "task" ? "PUT" : "POST"}`, true, onSubmitTask, onLoginError);
    }
  };

  const onSubmitTask = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (!restData?.errorMessage) {
        if(isEdit === "task" || isEdit === "subtask"){
          ToastManager.showToast(`${modalType === "subtask" ? "Subtask" : "Task" } updated successfully`, "Success")
        }else{
        ToastManager.showToast(`${modalType === "subtask" ? "Subtask" : "Task" } added to ${data?.name}`, "Success");
        }
        close(submitType);
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
    }
  };

  const handleMultiSelectAll = (selectedOptions: any) => {
    const options = processById.equipmentTypes || [];
    const isAllSelected = selectedOptions.some((opt: any) => opt.value === 0);
    const prevSelected = equipFormik.values.equipmentType || [];
    const wasAllSelected = prevSelected.some((opt: any) => opt.value === 0);

    let newSelected: any[] = [];

    if (isAllSelected && !wasAllSelected) {
      newSelected = [...options];
    } else if (!isAllSelected && wasAllSelected) {
      newSelected = [];
    } else {
      const realSelection = selectedOptions.filter((opt: any) => opt.value !== 0);
      const otherOptions = options.filter((opt: any) => opt.value !== 0);
      if (otherOptions.length > 0 && realSelection.length === otherOptions.length) {
        newSelected = [...options];
      } else {
        newSelected = realSelection;
      }
    }
    equipFormik.setFieldValue("equipmentType", newSelected);
  };

  const equipFormik = useFormik({
    initialValues: {
      equipmentType: [],
      assetTypeId: "",
      processName: "",
      processId: "",
    },
    validationSchema: equipValidation,
    onSubmit: (values, { resetForm }) => {
        onSubmitEquipForm(values);
        // if (submitType !== "add") {
          resetForm();
        // }
    },
  });

  const onSubmitEquipForm = (values: any) => {
    const payload = {
      equipmentTypeId: values.equipmentType?.some((type: any) => type.value === 0) 
        ? [0] 
        : (values.equipmentType?.map((type: any) => type.value) || null),
      processId: processById.processId,
    }
    console.log(payload, "payload");
    const url = `api/v2/config/task-equipment-types/?orgId=${sassOrgId}`;
    NetworkManager.sendJsonRequest(url, payload, "", "POST", true, (dataObj: any) => {
      if (dataObj) {
        const restData = JSON.parse(dataObj);
        if (!restData?.errorMessage) {
          ToastManager.showToast(`Equipment Type Added`, "Success");
          if (submitType === "add") {
            equipFormik.setFieldValue("equipmentType", []);
            }
            close(submitType);
        }else{
          ToastManager.showToast(restData.errorMessage, "Error");
        }
      }
    }, onLoginError);
  };

  return (
    <div>
    <Modal show={open} centered dialogAs={DraggableComponent} id="devEstPopup" size={`${modalType === "equipment" ? "lg" : "xl"}`}>
      <div className="modal-content new-interchange" id="devEstContentPopup" 
        // style={{  maxHeight: "100vh", overflowY: "auto"}}
      >
        <Modal.Header className="modal-header" closeButton={false}>
          <h5 className="modal-title mt-0">{modalType === "equipment" ? "Select Equipment Type" : modalType === "task" ? `${isEdit === "task" ? "Edit" : "Add"} Task` : `${isEdit === "subtask" ? "Edit" : "Add"} Sub Task`}</h5>
          <button type="button" className="isModal" style={{ marginLeft: "0px", background: "none" }} onClick={()=>close("cancel")} >
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal.Header>
        {modalType === "equipment" && 
          <form onSubmit={equipFormik.handleSubmit} className='modal-body'>
            <div className="row mb-2">
              <div className="col-md-6 mb-4">
                <InputField placeholder="Process Name" type="text" className="form-control" value={processById.processName} disabled/>
              </div>
            </div>
            <div className="row my-1">
              <div className="col-md-6 mb-4">
                <InputField type="text" className="form-control" placeholder="Asset Type"
                  value={processById.assetTypeId == "1" ? "Trailer" : processById.assetTypeId == "2" ? "Truck" : ""}
                  disabled
                />
              </div>
              <div className="col-md-6">
                  <ReactSelectField name="equipmentType" isMulti placeholder="Select Equipment Type"
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                    options={processById.equipmentTypes}
                    value={equipFormik.values.equipmentType}
                    onChange={(selected:any) => handleMultiSelectAll(selected)}
                  />
                  {equipFormik.touched.equipmentType && equipFormik.errors.equipmentType && (
                    <small className="ms-2 text-danger fw-700">{equipFormik.errors.equipmentType}</small>
                  )}
              </div>
            </div>
            <div className='modal-footer p-0'>
              <button type="submit" className="btn btn-dark" disabled={!equipFormik.values.equipmentType.length}
                onClick={() => setSubmitType("add")}>Save & Add Equipment Types</button>
              <button type="submit" className="btn btn-outline-dark" disabled={!equipFormik.values.equipmentType.length} 
                onClick={() => setSubmitType("save")}>Save & Close</button>
              <button type="button" className="btn btn-outline-light" onClick={() => close("cancel")}>Cancel</button>
            </div>
        </form>}
        {modalType !== "equipment" && <Modal.Body>
        <form onSubmit={taskFormik.handleSubmit} className="col-12">
          <div className="modal-body">
              <div className="row">
                <div className="col-md-4 mb-4">
                  <InputField placeholder="Process Name" type="text" className="form-control"  value={data?.processName} disabled/>
                </div>
                <div className="col-md-4 mb-4">
                  <InputField type="text" placeholder="Asset Type" className="form-control"  
                    value={(processById.assetTypeId || data?.assetTypeId) == "1" ? "Trailer" : (processById.assetTypeId || data?.assetTypeId) == "2" ? "Truck" : ""} disabled/>
                </div>
                <div className="col-md-4 mb-4">
                  <InputField placeholder="Equipment Type" type="text" className="form-control" title={data?.equipmentName}  value={data?.equipmentName} disabled/>
                </div>
              </div>
              <div className="row">
                {modalType === "task" ? 
                <div className='col-md-4 mb-4'>
                  <SelectField name="processType" className="form-select" placeholder="Process Type"
                    value={taskFormik.values.processType}
                    onChange={(e:any) => handleProcessChange(e)}
                    disabled={isEdit === "task"}
                  >
                    <option value="" disabled>Select</option>
                    {processById?.processTypes?.map((item:any, i: any) => (<option key={i} value={item.value}>{item.label}</option>))}
                  </SelectField>
                  {taskFormik.touched.processType && taskFormik.errors.processType && (
                    <small className="ms-2 text-danger fw-700">{taskFormik.errors.processType}</small>
                  )}
                </div> : 
                <div className='col-md-4 mb-4'>
                  <InputField placeholder="Process Type" type="text" className="form-control"  value={data?.processType} disabled={isEdit === "task" || modalType === "subtask"}/>
                </div>}
                <div className="col-md-4 mb-4">
                  <SelectField name="taskView" className="form-select" placeholder="Task List View"
                    value={taskFormik.values.taskView}
                    onChange={(e:any) => taskFormik.handleChange(e)}
                    disabled={isEdit === "task" || modalType === "subtask"}
                  >
                    <option value="" disabled>Select</option>
                    {taskFormik.values.processType === "CTPAT" ? (
                      <>
                        <option value="List View">List View</option>
                      </>
                    ) : taskFormik.values.processType === "Picture" ? (
                      <>
                      <option value="Picture List">Picture List</option>
                      <option value="Picture Tile View">Picture Tile View</option>
                      </>
                    ) : taskFormik.values.processType === "Light" || taskFormik.values.processType === "Reefer"? (
                      <option value="Panel List View">Panel List View</option>
                    ) : taskFormik.values.processType === "Tyre" || taskFormik.values.processType === "Tire" ? (
                      <option value="Individual Task">Individual Task</option>
                    ) : taskFormik.values.processType === "Tire and Brakes" ? (
                        <option value="Individual Image Task">Individual Image Task</option>
                    ) : taskFormik.values.processType === "General" ? (
                        <option value="List View">List View</option>
                    ) : (
                      <>
                        <option value="List View">List View</option>
                        <option value="Picture List">Picture List</option>
                        <option value="Individual Task">Individual Task</option>
                        <option value="Panel List View">Panel List View</option>
                      </>)}
                  </SelectField>
                  {taskFormik.values.taskView === "Panel List View" ? 
                    <small className="ms-2 mb-0 fst-italic">Tasks will be listed in the Panel's scrollable view.</small> :
                    taskFormik.values.taskView !== "" ?
                    <small className="ms-2 mb-0 fst-italic">Tasks will be displayed in a scrollable view.</small>: ""
                    }
                  {taskFormik.touched.taskView && taskFormik.errors.taskView && (
                    <small className="ms-2 text-danger fw-700">{taskFormik.errors.taskView}</small>
                  )}
                </div>
                <div className="col-md-4 mt-0">
                    <InputField placeholder="Task Name" type="text" name="taskName" className="form-control"
                      value={taskFormik.values.taskName}
                      onChange={taskFormik.handleChange}
                      disabled={modalType === "subtask"}
                    />
                    {taskFormik.touched.taskName && taskFormik.errors.taskName && (
                      <small className="ms-2 text-danger fw-700">{taskFormik.errors.taskName}</small>
                    )}
                </div>
              </div>
              <div className={`col-md-12 mb-2 ${modalType === "subtask" ? "d-none" : ""}`} >
                <InputField rows={2} name="taskDescription" className="form-control"
                  placeholder="Task Description"
                  value={taskFormik.values.taskDescription}
                  onChange={taskFormik.handleChange}
                />
                {/* {taskFormik.touched.taskDescription && taskFormik.errors.taskDescription && (
                  <small className="ms-2 text-danger fw-700">{taskFormik.errors.taskDescription}</small>
                )} */}
              </div>
              <div className={`row  g-3 align-item-center mb-3 mt-0 ${modalType === "subtask" ? "" : "d-none"}`}>
                <div className="col-md-4 mt-0">
                    <InputField type="text" className="form-control" placeholder="Sub Task Name"
                      value={subtaskName}
                      onChange={(e:any)=>setSubtaskName(e.target.value)}
                    />
                </div>
                <div className={`col-md-8 mt-0`} >
                  <InputField rows={1} className="form-control" placeholder="Sub Task Description"
                    value={subtaskDes}
                    onChange={(e:any)=>setSubtaskDes(e.target.value)}
                  />
                </div>
              </div>
              <div className={`row mb-2 ${modalType === "subtask" ? "d-none" : ""}`}>
                <ProcessTypeSpecific processType={taskFormik.values.processType} onDataChange={getProcessTypeData} isEdit={isEdit} eData={data} />
              </div>
              {modalType === "task" && taskFormik.values.processType !== "Tire and Brakes" && <div className={`col-md-12`}>
                <DescriptionPicture processType={taskFormik.values.processType} onDataChange={getPictureDescription} isEdit={isEdit} eData={data} processTypeData={processTypeData} />
              </div>}
              {modalType === "task" && processById?.isInterchangeEnabled && !["Picture", "Tire and Brakes", ""].includes(taskFormik.values.processType) && <div className={`col-md-12`}>
                <PDFTemplateConfig processType={taskFormik.values.processType} isEdit={isEdit} eData={data} onDataChange={getPdfTemplateConfig} processTypeData={processTypeData} />
              </div>}
          </div>
          <div className='modal-footer'>
            <>
              {!isEdit && 
              <button type="submit" className="btn btn-outline-dark" 
                disabled={!processTypeData?.isValid || (taskFormik.values.processType !== "Tire and Brakes" && !pictureDescription?.isValid) || (processById?.isInterchangeEnabled && !["Picture", "Tire and Brakes"].includes(taskFormik.values.processType) && !pdfTemplateConfig?.isValid)} 
                onClick={() => setSubmitType("add")}>
                {`Save & Add ${modalType === "task" ? "Task": "Subtask"}`}
              </button>}
              <button type="submit" className="btn btn-dark" 
                disabled={!processTypeData?.isValid || (taskFormik.values.processType !== "Tire and Brakes" && !pictureDescription?.isValid) || (processById?.isInterchangeEnabled && !["Picture", "Tire and Brakes"].includes(taskFormik.values.processType) && !pdfTemplateConfig?.isValid)} 
                onClick={() => setSubmitType("save")}>
                {isEdit  === "task" || isEdit  === "subtask" ? `Update ${modalType === "task" ? "Task": "Subtask"}` : "Save & Close"}
              </button>
            </>
            <button type="button" className="btn btn-outline-light" onClick={() => close("cancel")}>Cancel</button>
          </div>
        </form>
        </Modal.Body>}
      </div>
    </Modal>
    </div>
  )
}

export default ModalTaskList;

const CustomMultiValue = ({ data, index, selectProps }: any) => {
  const selectedValues = selectProps.value || [];
  if (index !== 0) return null;

  const totalCharCount = selectedValues.reduce((acc: number, item: any) => acc + item.label.length, 0);

  let visibleCount = 3;
  if (totalCharCount > 25) {
    visibleCount = 1;
  } else if (totalCharCount > 15) {
    visibleCount = 2;
  }

  const visibleLabels = selectedValues.slice(0, visibleCount).map((item: any) => item.label);
  const remainingCount = selectedValues.length - visibleCount;

  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
      <span>{visibleLabels.join(", ")}</span>
      {remainingCount > 0 && (
        <span className="count-badge" style={{ marginLeft: 5 }}>
          +{remainingCount}
        </span>
      )}
    </div>
  );
};

const CustomOption = (props: any) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
      />
      <label style={{ marginLeft: "8px" }}>{props.label}</label>
    </components.Option>
  );
}; 